import "./App.css";
import HomePage from "./pages/HomePage";
import { Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import AboutUsPage from "./pages/AboutUsPage";
import Footer from "./components/Footer";
import ContactUsPage from "./pages/ContactUsPage";
import ArchivePage from "./pages/ArchivePage";
import UniversalPricesPage from "./pages/UniversalPricesPage";
import GalleryPage from "./pages/GalleryPage";
import TermsConditionsPage from "./pages/TermsConditionsPage";
import { getApiBaseUrl, getSocketBaseUrl, getSocketPath, apiFetch } from "./api/client";

const App = () => {
  const [currencies, setCurrencies] = useState([]);
  const [coins, setCoins] = useState([]);
  const [nimaiis, setNimaiis] = useState([]);
  const [exchangeData, setExchangeData] = useState({});
  const [viewsData, setViewsData] = useState({});
  const [uniPrices, setUniPrices] = useState([]);
  const [announcement, setAnnouncment] = useState({});

  useEffect(() => {
    const socketUrl = getSocketBaseUrl();
    if (!socketUrl) return;

    const socket = io(socketUrl, {
      path: getSocketPath(),
      transports: ["polling", "websocket"],
      timeout: 20000,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    socket.on("getCurrencies", async (data) => {
      // Swap elements at index 0 and 7
      [data[0], data[7]] = [data[7], data[0]];

      // Swap elements at index 1 and 8
      [data[1], data[8]] = [data[8], data[1]];
      // console.log(data);
      setCurrencies(data);
    });
    socket.on("getNimaiis", async (data) => {
      // console.log(data);
      setNimaiis(data);
    });

    socket.on("getCoins", async (data) => {
      // console.log(data);
      setCoins(data);
    });

    socket.on("getUniRates", async (data) => {
      // console.log(data);
      setUniPrices(data);
    });

    const getCurrencies = async () => {
      const res = await apiFetch("/api/getallcurrencies", { method: "POST" });
      const resData = await res.json();
      // console.log(resData);

      let currencies = resData.AllCurrensies;

      // Swap elements at index 0 and 7
      [currencies[0], currencies[7]] = [currencies[7], currencies[0]];

      // Swap elements at index 1 and 8
      [currencies[1], currencies[8]] = [currencies[8], currencies[1]];

      setCurrencies(currencies);
      setViewsData({
        today: resData.todayCountVal,
        yesterday: resData.yesterdayCountVal,
        all: resData.totalCountVal,
      });
    };
    const getCoins = async () => {
      const res = await apiFetch("/api/getallcoins", { method: "POST" });
      const resData = await res.json();
      // console.log(resData);

      setCoins(resData);
    };
    const getNimaiis = async () => {
      const res = await apiFetch("/api/getallnimaiis", { method: "POST" });
      const resData = await res.json();
      // console.log(resData);

      setNimaiis(resData);
    };
    const getExchangeData = async () => {
      const res = await apiFetch("/api/getConfig", { method: "GET" });
      const resData = await res.json();


       setExchangeData(resData);
    };

    const getUniRates = async () => {
      const res = await apiFetch("/api/uni-rates", { method: "GET" });
      const resData = await res.json();
      // console.log(resData.uniRates);

      setUniPrices(resData.uniRates);
    };

    const getAnnouncement = async () => {
      const res = await apiFetch("/api/getmsg", { method: "POST" });
      const resData = await res.json();
      // console.log("announce", resData);

      setAnnouncment(resData);
    };

    getUniRates();
    getCurrencies();
    getCoins();
    getNimaiis();
    getExchangeData();
    getAnnouncement();
  }, []);

  return (
    <div className="App">
      <Header exchangeData={exchangeData} />
      <Routes>
        <Route
          path="/"
          exact
          element={
            <HomePage
              currencies={currencies}
              coins={coins}
              nimaiis={nimaiis}
              uniPrices={uniPrices}
              exchangeData={exchangeData}
              viewsData={viewsData}
              announcement={announcement}
            />
          }
        />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route
          path="/contact-us"
          element={<ContactUsPage exchangeData={exchangeData} />}
        />
        <Route
          path="/archive"
          element={
            <ArchivePage
              currencies={currencies}
              coins={coins}
              nimaiis={nimaiis}
            />
          }
        />
        <Route
          path="/prices"
          element={<UniversalPricesPage uniPrices={uniPrices} />}
        />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/terms-conditions" element={<TermsConditionsPage />} />
      </Routes>
      <Footer exchangeData={exchangeData} />
    </div>
  );
};

export default App;
